const AbstractEntity = require('@/lib/Entities/AbstractEntity');
const { populate } = require('@/functions/objects');
const { toBool, toInt } = require('@/functions/transform');

class Category extends AbstractEntity {
    constructor(data = {}) {
        super();

        /**
         * @type {string}
         */
        this.name = '';

        /**
         * TODO: Remove
         *
         * @type {Product[]}
         */
        this.products = [];

        /**
         * TODO: Remove
         *
         * @type {Ticket}
         */
        this.tickets = [];

        /**
         * @type {boolean}
         */
        this.allowPriceEdit = false;

        /**
         * @type {boolean}
         */
        this.hasFood = false;

        /**
         * @type {boolean}
         */
        this.hasNonFood = false;

        /**
         * @type {string}
         */
        this.confirmationText = '';

        populate(this, data);
    }

    getHydrationMap() {
        return Object.assign(
            {},
            super.getHydrationMap(),
            {
                allowPriceEdit: toBool,
                confirmationText: {
                    transform(value, allData) {
                        if (!value) {
                            return '';
                        }

                        return allData.isHydrated ? value : value.replace(/(<([^>]+)>)/ig, '');
                    },
                },
                ID: {
                    field: ['ID', 'catID'],
                    transform: toInt,
                },
                name: {},
            }
        );
    }
}

module.exports = Category;
